import React, {useState, useEffect} from "react";
import {StyledAssignMenu} from "./AssignMenu.style";
import {useForm} from "components/molecules/Form";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import Button from "components/molecules/Button";
import copyIcon from "../../../../../../assets/Store/copyIcon.svg";
import addIcon from "../../../../../../assets/Store/addIcon.svg";
import manageStores from "services/manageSores";
import {useSelector} from "react-redux";
import Toast from "components/molecules/Toast";
import { useAuthContext } from "Context/authContext";

const AssignMenu = ({setFormData, setActiveTab}) => {
    const [form] = useForm();
    const [activeMenu, setActiveMenu] = useState(0);
    const [availableStores, setAvailableStores] = useState([]);
        const business = useSelector(state => state.business.id);
        const { user } = useAuthContext();
        const businessIdFromAuth = user?.businessId;
        const businessId = businessIdFromAuth || business;

    // Fetch available stores for copying menu
    useEffect(() => {
        const fetchStores = async () => {
            if (businessId && activeMenu === 0) {
                try {
                    const response = await manageStores.getStoresForCopy(businessId);
                    setAvailableStores(response.stores || []);
                } catch (error) {
                    console.error("Failed to fetch stores:", error);
                }
            }
        };
        fetchStores();
    }, [businessId, activeMenu]);

    const handleSubmit = e => {
        // Validate if copying menu and source store is selected
        if (activeMenu === 0 && (!e?.source_store_id)) {
            Toast({
                type: "error",
                message: "Please select a store to copy menu from"
            });
            return;
        }
        
        // Find roundtrip_business_id for both copy and create new modes
        let roundtripBusinessId = null;
        
        if (activeMenu === 0 && e?.source_store_id) {
            // Copy mode: get from selected source store
            const sourceStoreId = e?.source_store_id?.value || e?.source_store_id;
            const sourceStore = availableStores.find(store => store._id === sourceStoreId);
            roundtripBusinessId = sourceStore?.roundtrip_business_id || null;
            console.log("Found source store roundtrip_business_id:", roundtripBusinessId);
        } else if (activeMenu === 1) {
            // Create new mode: get from any available store in the business
            const firstStoreWithRoundtrip = availableStores.find(store => store.roundtrip_business_id);
            roundtripBusinessId = firstStoreWithRoundtrip?.roundtrip_business_id || null;
            console.log("Found business roundtrip_business_id from existing store:", roundtripBusinessId);
        }
        
        const stepThree = {
            menu_action: activeMenu === 0 ? 'copy' : 'create_new',
            source_store_id: activeMenu === 0 ? (e?.source_store_id?.value || e?.source_store_id) : null,
            source_roundtrip_business_id: roundtripBusinessId, // Add this for ReviewStore to use
        };
        
        console.log("Menu assignment data:", stepThree);
        console.log("Form data received:", e);
        
        setFormData(prev => ({
            ...prev,
            form3: {...stepThree},
        }));
        setActiveTab(2);
    };
    return (
        <StyledAssignMenu>
            <Form form={form} onSubmit={handleSubmit}>
                <h2 className="title">Assign Menu</h2>

                <div className="menu-wrap">
                    <div className={`${activeMenu === 0 ? "active" : ""} menu`} onClick={() => setActiveMenu(0)}>
                        <img src={copyIcon} alt="copyIcon" className="icon" />
                        <strong className="title">Copy from Existing Store</strong>
                        <span className="desc">Duplicate menu from another Store</span>
                    </div>
                    <div className={`${activeMenu === 1 ? "active" : ""} menu`} onClick={() => setActiveMenu(1)}>
                        <img src={addIcon} alt="addIcon" className="icon" />
                        <strong className="title">Create New Menu</strong>
                        <span className="desc">Start with a fresh menu</span>
                    </div>
                </div>

                {activeMenu === 0 && (
                    <Form.Item
                        label="Select Store to Copy Menu From *"
                        type="select"
                        rounded
                        name="source_store_id"
                        lg
                        placeholder="Choose a store"
                        $bgWhite
                        options={availableStores.map(store => ({
                            label: store.title || store.name,
                            value: store._id
                        }))}
                        rules={[
                            {
                                required: true,
                                message: "Please select a store to copy menu from",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                )}

                <div className="btn-wrap">
                    <Button type="button" variant="secondary" onClick={() => setActiveTab(0)}>
                        Previous
                    </Button>
                    <Button variant="primary">Continue</Button>
                </div>
            </Form>
        </StyledAssignMenu>
    );
};

export default AssignMenu;
